import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { AccordionGroupChangeEventDetail, AccordionGroupCustomEvent } from '@ionic/core';
import { History } from 'src/app/interfaces/api/shipment';
import { TDTransaction } from 'src/app/interfaces/api/transaction';
import { ControllerService } from 'src/app/services/controller.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { openLinkNewTab } from 'src/helpers';
import { Clipboard } from '@capacitor/clipboard';
// import * as moment from 'moment';

@Component({
  selector: 'app-product-card-detail-transaksi',
  templateUrl: './product-card-detail-transaksi.component.html',
  styleUrls: ['./product-card-detail-transaksi.component.scss'],
})
export class ProductCardDetailTransaksiComponent implements OnInit {
  @Output() doRefresh = new EventEmitter();
  @Input() isLoading: boolean;
  @Input() data: TDTransaction;
  @Input() status: number;
  @ViewChild('openclose', { static: true }) openclose: ElementRef;
  @ViewChild('modalReview') modalReview!: ModalController;
  deliveryInfoIsOpen = false;
  isLoadingTracking = false;
  dataHistoryTracking: History[];

  fillBtnLike: string[] = [];
  fillBtnDislike: string[] = [];
  review: number[] = [];
  narration: string[] = [];
  disabledReview: boolean[] = [];
  weight: string;

  constructor(
    private transactionService: TransactionService,
    private toastController: ToastController,
    private controllerService: ControllerService,
  ) {}

  ngOnInit() {
    this.data?.td_transaction_product?.forEach(detail => {
      if (detail.review != null) {
        if (detail.review === 1) {
          this.fillBtnLike[detail.id] = 'solid';
          this.fillBtnDislike[detail.id] = 'outline';
        } else {
          this.fillBtnDislike[detail.id] = 'solid';
          this.fillBtnLike[detail.id] = 'outline';
        }
        this.review[detail.id] = detail.review;
        this.narration[detail.id] = (detail.narration ?? '').trim();
        this.disabledReview[detail.id] = true;
      } else {
        this.fillBtnLike[detail.id] = 'outline';
        this.fillBtnDislike[detail.id] = 'outline';
        this.review[detail.id] = -1;
        this.narration[detail.id] = '';
        this.disabledReview[detail.id] = false;
      }
    });
  }

  accordionGroupChange(event: any) {
    const customEvent = event as CustomEvent<AccordionGroupChangeEventDetail>;
    this.deliveryInfoIsOpen = customEvent.detail.value ? true : false;
  }

  getTracking() {
    this.isLoadingTracking = true;
    this.transactionService.getTracking(this.data.id).subscribe({
      next: async res => {
        this.dataHistoryTracking = res.history;
      },
      complete: () => {
        this.isLoadingTracking = false;
      },
    });
  }

  async copyToClipboard(resi: string) {
    // navigator.clipboard.writeText(resi);
    await Clipboard.write({
      // eslint-disable-next-line id-blacklist
      string: resi,
    });
    this.presentToast(`Successfully copy ${resi} to clipboard`);
  }

  changeToLikeOrDislike(id, type: 'like' | 'dislike') {
    if (this.disabledReview[id]) {
      return;
    }

    if (type === 'like') {
      this.fillBtnLike[id] = 'solid';
      this.fillBtnDislike[id] = 'outline';
      this.review[id] = 1;
    } else {
      this.fillBtnLike[id] = 'outline';
      this.fillBtnDislike[id] = 'solid';
      this.review[id] = 0;
    }
  }

  sendReview(id) {
    // console.log(id, this.review[id], this.narration[id])
    this.transactionService
      .reviewProduct(id, {
        narration: this.narration[id].trim(),
        review: this.review[id],
      })
      .subscribe({
        next: async res => {
          // this.editPasswordForm.reset();
          this.disabledReview[id] = true;
          this.modalReview.dismiss();
          await this.controllerService.presentToast(
            {
              color: 'primary',
              duration: 3000,
              message: res.message,
            },
            true,
          );
          this.doRefresh.emit(null);
        },
        error: async err => {
          console.log(err);

          // await this.controllerService.presentToast({
          //   color: 'danger',
          //   duration: 3000,
          //   message: 'Terjadi kesalahan pada aplikasi, hubungi admin!'
          // });

          // if (err instanceof ValidationError) {
          //   err.render(this.editPasswordForm, this.editPasswordFormControlOptions);
          // }
        },
      });
  }

  goToMaps() {
    const url = new URL(
      `https://www.google.com/maps/search/?api=1&query=${this.data.mh_warehouse?.latitude},${this.data.mh_warehouse?.longitude}`,
    );
    openLinkNewTab(url.href);
  }

  protected async presentToast(message: string, duration: number = 1000): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      mode: 'ios',
    });
    return await toast.present();
  }

  // formatDate(date) {
  //   let formated = moment(date);
  //   console.log(formated, formated.format("HH:mm | DD MMM YYYY"))

  //   date = new Date(date);
  //   var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

  //   var offset = date.getTimezoneOffset() / 60;
  //   var hours = date.getHours();
  //   console.log(date.getTime(), date.getTimezoneOffset(), newDate, offset, hours)

  //   newDate.setHours(hours - offset);
  //   console.log("asd", newDate);
  //   return formated.format("HH:mm | DD MMM YYYY");

  // }
}
